import { useTranslation } from "react-i18next";

import type { VoucherListSortValue } from "../types";

type SortByOptions = {
  value: VoucherListSortValue;
  label: string;
};

export const useSortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("voucher", {
    keyPrefix: "voucherListPage.filters.sortByOptions"
  });

  return [
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    }
  ];
};
